/* eslint-disable max-len */
import Image from "next/image";
import Link from "next/link";

import { ROUTES } from "@/helpers/routes";
import PageSeo from "@/shared/components/PageSeo";

import Layout from "../../shared/components/layout";

export default function StrategicPartnerDetails() {
    return (
        <div>
            <PageSeo title="DWF | The Gender Index" pathname={ROUTES.headlinePartnersDwf} />
            <Layout>

                <div className='singleLayout partnerDetailsPage'>
                    <div className='edgeBannerWrapper'>
                        <div className='edgeBanner'>
                        </div>
                        <div className="bannerDetailsWrap">
                            <div className="leftPane">
                                <Link className="backBtn" href="/headline-partners">&lt; Back</Link>
                                <h4>Headline partner</h4>
                                <h1>DWF</h1>
                                <ul className="commonList link">
                                    <li><a href="https://dwfgroup.com/en" target="_blank" rel="noreferrer">www.dwfgroup.com/en</a></li>
                                    <li><a href="https://www.linkedin.com/company/dwf/?originalSubdomain=uk" target="_blank" rel="noreferrer">www.linkedin.com/company/dwf/?originalSubdomain=uk</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="logo-image dwf">
                        <Image
                            src="/images/PartnerLogos/dwf.png"
                            alt="logo_image"
                            width={150}
                            height={60}
                            loading="lazy"
                        />
                    </div>
                    <h6>Who we are</h6>
                    <p className='body-default-copy-large'>DWF is a leading global provider of integrated legal and business services, with a purpose to deliver positive outcomes with our colleagues, clients and communities.</p>
                    <p className='body-default-copy-large'>Our integrated approach includes Legal Services, Legal Operations, and Business Services, and our unique ability to combine these services into bespoke solutions for our clients is what sets us apart. With over
                        4,500 colleagues across 35+ locations worldwide, we deliver greater efficiency, price certainty, and transparency, without compromising on quality and service.</p>
                    <h6>Our commitment to diversity, equality and inclusion (DE&I)</h6>
                    <p className='body-default-copy-large'>As the financial partner to the innovation economy, we know that innovation needs different ideas, technologies, and
                        voices to reshape our world.</p>
                    <p className='body-default-copy-large'>Our client relationships extend far beyond our work, resulting in award-winning D&I programmes and partnerships. We are also determined to ensuring our colleagues
                        feel heard, respected and valued, and we are truly committed to fair representation and equal opportunities for all. Not just to meet client expectations, but because diversity brings strength, individuality
                        drives innovation, and we are always better together.</p>
                    <p className='body-default-copy-large'>Our global Diversity & Inclusion (D&I) strategy, supported by executive-level sponsorship, has clear targets and KPIs. Our DE&I leadership group, featuring senior leads from
                        across the business, drives this strategy forward. Active colleague-led network groups create an environment where all perspectives are valued and every individual is supported to be themselves at work.</p>
                    <h6>Working with investors</h6>
                    <p className='body-default-copy-large'>Whether supporting institutional investors, private equity and venture capital funds, growth companies, or management teams, we provide strategic guidance to help our clients achieve their commercial objectives while managing risk effectively.
                        We understand the nuances of investment transactions and have deep-rooted experience across the investment lifecycle, always ensuring transactions are structured for long-term success.</p>
                    <p className='body-default-copy-large'>The venture capital (VC) and private equity (PE) landscapes in the UK are pivotal in driving innovation and growth. However, access to funding remains uneven, with
                        female founders—particularly Black and Asian female founders—facing disproportionate barriers to investment. We are committed to addressing this imbalance by actively supporting female founders and investors, helping
                        them navigate the complexities of fundraising and investment structuring. Through our extensive industry relationships and market knowledge, we work to connect female-led businesses with the right funding opportunities and
                        provide legal expertise that fosters growth and sustainability.</p>
                </div>
            </Layout>
        </div>
    );
}

